/**
 * @generated SignedSource<<ef8c6a712d7a1a82d4af3b32046de030>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PerpsPoolThumbSubscription$variables = {
  id: string;
};
export type PerpsPoolThumbSubscription$data = {
  readonly node: {
    readonly lpSize?: {
      readonly valueUsd: bigint;
    };
    readonly xlpSize?: {
      readonly valueUsd: bigint;
    };
  } | null | undefined;
};
export type PerpsPoolThumbSubscription = {
  response: PerpsPoolThumbSubscription$data;
  variables: PerpsPoolThumbSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "valueUsd",
    "storageKey": null
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "lpSize",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Balance",
      "kind": "LinkedField",
      "name": "xlpSize",
      "plural": false,
      "selections": (v2/*: any*/),
      "storageKey": null
    }
  ],
  "type": "PerpsAccount",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PerpsPoolThumbSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PerpsPoolThumbSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae043013b14ca0b6846faf6aa9a4ed3f",
    "id": null,
    "metadata": {},
    "name": "PerpsPoolThumbSubscription",
    "operationKind": "subscription",
    "text": "subscription PerpsPoolThumbSubscription(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PerpsAccount {\n      lpSize {\n        valueUsd\n      }\n      xlpSize {\n        valueUsd\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "29c55dd4a54059a282843d02636125e8";

export default node;
